define.alias("shared/components/shared/button/upgrade", "settings/components/shared/button/upgrade");